import PropTypes from 'prop-types';
import { Box, InputBase, IconButton } from '@mui/material';
import Iconify from '../iconify';

LogSearchBar.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  placeholder: PropTypes.string,
};

export default function LogSearchBar({ value, onChange, onClose, placeholder = 'Search Log...' }) {
  return (
    <Box sx={{ display: 'flex', height: '39px', padding: '0 10px', alignItems: 'center', gap: '8px', alignSelf: 'stretch', borderRadius: '6px', border: '1px solid #C1C9D0', backgroundColor: '#FFF' }}>
      <Iconify icon="mdi:magnify" sx={{ color: 'text.disabled', flexShrink: 0 }} />
      <InputBase autoFocus fullWidth placeholder={placeholder} value={value} onChange={onChange} sx={{ fontSize: '14px' }} />
      <IconButton size="small" onClick={onClose} aria-label="Close search" sx={{ p: 0, flexShrink: 0 }}>
        <Iconify icon="mdi:close" sx={{ fontSize: '18px', color: 'text.disabled' }} />
      </IconButton>
    </Box>
  );
}